<template>
  <v-card flat class="conteneurLead" id="conteneurLead">
    <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
      <v-btn icon @click="cancelDialogEdit()"><v-icon class="white--text">close</v-icon></v-btn>
      <span class="title">{{ $t('lead') }} #{{ leadDialog.id }}</span>
      <v-spacer></v-spacer>
      <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogEdit()" class="white--text">{{ $t('submit') }}</v-btn>
    </v-card-title>

    <v-tabs
      grow
      centered
      slider-color="secondary"
      v-model="currentTab"
    >
      <!-- <v-tab :key="'tab_fiche'"><v-icon>assignment</v-icon>Fiche</v-tab>
      <v-tab :key="'tab_chat'"><v-icon>question_answer</v-icon>Chat</v-tab> -->
      <v-tab
        v-for="tab of tabs"
        :key="tab.index"
        class="primary--text"
      >
        <v-icon class="primary--text">{{tab.icone}}</v-icon>
        {{tab.name}}
      </v-tab>

      <v-tab-item :key="'tab_fiche'" style="overflow: auto;">
        <!-- Chargement -->
        <div v-if="loading" class="text-xs-center">
          <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
        </div>
        <v-card-text v-else :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : ''">
          <v-container fluid grid-list-md class="conteneurFicheLead">
            <v-layout row wrap>
              <!-- infos lead -->
              <v-flex xs12 md5>
                <!-- Motifs -->
                <v-chip
                  v-for="(motiff, i) in leadDialog.motifs" :key="i"
                  label
                  color="secondary"
                  text-color="white"
                >
                  <v-icon left>label</v-icon>{{ motiff }}
                </v-chip>
                <v-chip v-if="leadDialog.motif" label color="secondary" text-color="white">
                  <v-icon left>label</v-icon>{{ leadDialog.motif }}
                </v-chip>

                <!-- MOTIF COMMUN et CUSTOM A TOUS-->
                <!-- <v-layout row wrap v-if="leadDialog.special_client === '' || leadDialog.special_client === 'hisense'"> -->
                <v-layout row wrap >
                  <v-flex xs12 id="selectMotifLead">
                    <v-select
                    :items="custom_motifs"
                    :label="$tc('tags', 1, {count: ''})"
                    menu-props="auto"
                    v-on:change="changeMotif"
                    ></v-select>
                  </v-flex>
                </v-layout>
                
                <!-- civilité -->
                <wz-select-gender :gender.sync="leadDialog.gender"></wz-select-gender>
                <!-- prénom et nom -->
                <v-layout row>
                  <v-text-field v-model="leadDialog.fname" :label="$t('firstName')" xs12 md6 class="mr-1"></v-text-field>
                  <v-text-field v-model="leadDialog.lname" :label="$t('lastName')" xs12 md6 class="ml-1"></v-text-field>
                </v-layout>
                <!-- email -->
                <v-layout row>
                  <v-text-field 
                    v-model="leadDialog.email"
                    label="Email" 
                    prepend-icon="mail_outline"
                    type="email" 
                    data-vv-name="email"
                    v-validate="'required|email'"
                    :error="wzErrors.has('email')"
                    :error-messages="wzErrors.collect('email')"
                  ></v-text-field>
                </v-layout>
                <!-- téléphones -->
                <v-layout row>
                  <v-text-field v-model="leadDialog.tel" prepend-icon="phone" :label="$t('phone')" xs12 md6 class="mr-1"></v-text-field>
                  <v-text-field v-model="leadDialog.C2C" prepend-icon="phone" :label="$t('callback')" xs12 md6 class="ml-1"></v-text-field>
                </v-layout>
                <!-- société -->
                <v-layout row>
                  <v-text-field v-model="leadDialog.company" prepend-icon="business" :label="$t('company')"></v-text-field>
                </v-layout>
                <!-- url (de la société) -->
                <v-layout row>
                  <v-text-field v-model="leadDialog.url" prepend-icon="language" label="URL"></v-text-field>
                </v-layout>
                <!-- date de rendezvous -->
                <v-layout row v-if="getMeeting !== ' '">
                  <v-text-field v-model="getMeeting" prepend-icon="event" label="Meeting">titi</v-text-field>
                </v-layout>
              </v-flex>
              <v-spacer></v-spacer>
              <!-- infos lead API et connecteurs -->
              <v-flex xs12 md6>
                <!-- IP -->
                <v-layout row>
                  <v-text-field v-model="leadDialog.ip" prepend-icon="device_hub" :label="$t('ipAddress')" readonly></v-text-field>
                </v-layout>
                <!-- question posée par le lead -->
                <v-layout row>
                  <v-textarea
                    v-model="leadDialog.question"
                    prepend-icon="help_outline"
                    :label="$t('leadQuestion')"
                    readonly
                  ></v-textarea>
                </v-layout>
                
                <!-- <v-alert v-else color="secondary" icon="info" value="true">
                  {{ $tc('tags', 0) }}
                </v-alert> -->

                <!-- commentaires de l'agent sur le lead -->
                <v-layout row>
                  <v-textarea
                    v-model="leadDialog.comment"
                    prepend-icon="comment"
                    :label="$t('comment')"
                  ></v-textarea>
                </v-layout>
                <!-- Les champs custom de VIS_INFO -->
                <v-layout row wrap >
                  <v-text-field 
                    v-for="(item, i) in custom_champs" :key="i"
                    prepend-icon="info"
                    :label="item.name"
                    v-model="item.value"
                  >
                  </v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-3"></v-divider>

            <v-layout row wrap>
              <!-- infos getquanty -->
              <v-flex v-if="leadDialog.getquanty  && brideMenu('stats_leads_getquanty') === '1'" xs12 md6>
                <v-expansion-panel >
                  <v-expansion-panel-content>
                    <div slot="header">
                      <img class="logo-company" src="https://www.getquanty.com/wp-content/uploads/2016/10/Logo-GetQuanty-Petit.png"/>
                    </div>
                    <v-list two-line dense subheader class="grey lighten-5">
                      <div v-for="(field, i) in leadDialog.getquanty" :key="i">
                        <v-list-tile  v-if="field && field[1] && field[0] != 'partenaire'"  avatar>
                          <v-list-tile-action>
                            <v-icon>{{
                              field[0] == 'telephone' ? 'phone'
                            : field[0] == 'raison sociale' ? 'business'
                            : field[0] == 'effectif' ? 'people'
                            : field[0] == 'adresse' ? 'location_on'
                            : ''
                          }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ field[1] }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ field[0] }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </div>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>

              <!-- Chaleur Watcheezy -->
              <v-flex v-if="leadDialogChaleur.chaleur && brideMenu('stats_leads_chaleur') === '1'" xs12 md6>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <div slot="header">
                      {{ $t('leadHeat') }}
                      <v-chip v-if="leadDialogChaleur.chaleur" color="green" class="white--text">{{ leadDialogChaleur.chaleur }}°</v-chip>
                    </div>
                    <v-list two-line dense subheader class="grey lighten-5">

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportHasChatted') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialog.hasChatted ? $t('yes') : $t('no')}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.hasChatted" color="green" class="white--text">+{{ leadDialogChaleur.details.hasChatted }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportHasBeenTarget') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialog.hasBeenTarget ? $t('yes') : $t('no')}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.hasBeenTarget" color="green" class="white--text">+{{ leadDialogChaleur.details.hasBeenTarget }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportTel') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialogChaleur.details.tel ? $t('yes') : $t('no')}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.tel" color="green" class="white--text">+{{ leadDialogChaleur.details.tel }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportEmail') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialogChaleur.details.email ? $t('yes') : $t('no')}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.email" color="green" class="white--text">+{{ leadDialogChaleur.details.email }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportDuration') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialog.duration | duration }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.duration" color="green" class="white--text">+{{ leadDialogChaleur.details.duration }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportBasket') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialog.basket }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.basket" color="green" class="white--text">+{{ leadDialogChaleur.details.basket }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile xs12 md6 lg3>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('exportPurchase') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ leadDialog.purchase }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip v-if="leadDialogChaleur.details.purchase" color="green" class="white--text">+{{ leadDialogChaleur.details.purchase }}</v-chip>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

      </v-tab-item>


      <v-tab-item :key="'tab_chat'">
        <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : ''" class="pa-0">
          <wz-histo-chats
            v-if="leadDialog.id"
            :params="'visId=' + leadDialog.id"
            :numChatsTotal="String(0)"
            chatHeight="100%"
            type="satisfaction"
            scroll
          ></wz-histo-chats>
        </v-card-text>
      </v-tab-item>
    </v-tabs>

    <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && currentTab == 0">
      <v-spacer></v-spacer>
      <v-btn flat @click="cancelDialogEdit()">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" @click="submitDialogEdit()">{{ $t('submit') }}</v-btn>
    </v-card-actions>

  </v-card>
</template>

<style type="text/css">
  img.logo-company {
      max-width: 150px;
  }
  .conteneurLead .v-window {
    height: calc(100% - 72px);
  }
  .conteneurLead .v-tabs__item--active {
    background: #edf4fc;
  }
  #selectMotifLead .v-menu {
    position: static ! important;
  }
</style>

<script>
import { MOTIFS_ORPI, MOTIFS_NUXE, MOTIFS_INOYA } from '../../constants'
import _ from 'lodash'
import { mapState } from 'vuex'
import * as moment from 'moment'
// import json2csv from 'json2csv'
export default {
  props: {
    leadDialog: {
      type: Object,
      default: {}
    },
    custom_motifs: {
      type: Array,
      default: []
    },
    custom_champs: {
      type: Array,
      default: []
    },
    hideLead: {
      type: Boolean,
      default: false
    },
    showHisto: {
      type: Boolean,
      default: true
    },
    histoChat: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      resFromAjax: null,
      currentTab: 0,
      tabs: [],
      nbLeads: 0,
      nbVisits: 0,
      nbCreations: 0,
      nbChats: 0,
      motif: null,
      // leadsDetails: [],
      /**
       * Indique que seuls les leads
       * de la période sont affichés
       * @type {Boolean}
       */
      leadsOfPeriod: true,

      /**
       * Indique que seuls les leads
       * créés sont affichés
       * @type {Boolean}
       */
      onlyCreatedLeads: false,

      /**
       * Gestion du lead dans le dialog
       * @type {Boolean}
       */
      dialogEdit: false,
      dialogRemove: false,
      dateSendLead: 0,
      default_motif: [
        { text: _.upperFirst(this.$t('support')), value: 'support' },
        { text: _.upperFirst(this.$t('lead')), value: 'lead' },
        { text: _.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' },
        { text: _.upperFirst(this.$t('estimate')), value: 'devis' },
        { text: _.upperFirst(this.$t('reservation')), value: 'resa' },
        { text: _.upperFirst(this.$t('contact')), value: 'contact' }
      ],
      meeting: ''
    }
  },

  computed: {
    // ...mapGetters('_Stats', ['params']),
    // ...mapGetters('_Sites', ['GET_SITE_BY_ID']),
    ...mapState('_User', ['brides']),
    motifs () {
      // ORPI
      if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
        return MOTIFS_ORPI
      }
      // NUXE
      if (this.$store.state._User.entKey === '9f1d52167b4128993ffa1c7b92207c4c') {
        return MOTIFS_NUXE
      }
      // INOYA
      if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7') {
        return MOTIFS_INOYA
      }

      let motifs = _.map(this.leadsDetails, 'motifs')
      motifs = _.filter(motifs, m => { return m.length })
      let res = []
      _.each(motifs, motif => {
        _.each(motif, m => {
          res.push(m)
        })
      })

      return _.uniq(res)
    },
    leadDialogChaleur () {
      return this.chaleurLead(this.leadDialog)
    },
    getMeeting () {
      if (this.leadDialog.date_rappel && this.leadDialog.heure_rappel) {
        return this.leadDialog.date_rappel.concat(' ', this.leadDialog.heure_rappel)
      } else {
        return ''
      }
    }
  },

  mounted () {
    if (this.showHisto) {
      if (this.hideLead) {
        this.tabs = [
          { index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }
        ]
      } else {
        this.tabs = [
          { index: 0, name: this.$t('leadEditor'), icone: 'assignment' },
          { index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }
        ]
      }
    } else {
      this.tabs = [
        { index: 0, name: this.$t('leadEditor'), icone: 'assignment' }
      ]
    }
    // si les filtres sont chargés, il est possible de lancer la/les requêtes afin de remplir les stats
    // this.loading = true
    // this.getLeadsInfos()
    // this.getLeads()
    // this.getChats()
    // if (this.histoChat && this.leadDialog.id) {
    //   this.showLead(this.leadDialog)
    // }
    // console.log('this.leadDialog', this.leadDialog)
  },
  updated () {
  },
  methods: {
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    changeMotif (e) {
      // console.log('changeMotif', e)
      this.leadDialog.motif = e
      // console.log('this.leadDialog', this.leadDialog)
    },
    /**
     * Dialogue d'édition d'un lead
     */
    cancelDialogEdit () {
      // this.dialogEdit = false
      this.$emit('closeDialog')
    },

    submitDialogEdit () {
      console.log('submitDialogEdit')
      this.dialogEdit = false
      // modifie les infos du lead de la BDD
      let dataToPost = new window.FormData()
      dataToPost.append('session', this.leadDialog.id)
      let leadFormatted = _.cloneDeep(this.leadDialog)
      console.log('--> this.leadDialog', this.leadDialog)
      // replace les champs custome dans le VIS-INFO
      this.custom_champs.forEach(function (data) {
        leadFormatted[data.name] = data.value
      })
      // console.log('custom_champs', this.custom_champs)
      // site
      leadFormatted.site = leadFormatted.siteId
      delete leadFormatted.siteId
      // getquanty
      delete leadFormatted.getquanty
      // dates
      // création
      if (leadFormatted.creation !== '') {
        leadFormatted.date = moment(leadFormatted.creation, 'L').format('X')
      }
      delete leadFormatted.creation
      // dernière visite
      if (leadFormatted.last !== '') {
        leadFormatted.last = moment(leadFormatted.last, 'L').format('X')
      }
      // chaleur
      delete leadFormatted.basket
      delete leadFormatted.hasChatted
      delete leadFormatted.hasBeenTarget
      delete leadFormatted.motifs
      delete leadFormatted.purchase

      dataToPost.append('infos', JSON.stringify(leadFormatted))
      this.axios.post('put/lead.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // remplacer le lead qui doit être modifié par celui dans le dialog
        this.$emit('updateLead', this.leadDialog)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
    },

    /**
     * Calcul de la chaleur d'un lead
     */
    // chaleur () {
    //   return this.leadsDetails.map(lead => {
    //     return this.chaleurLead(lead).chaleur
    //   })
    // },

    chaleurLead (lead) {
      let chaleur = 0
      let details = {}
      let points = 0
      // Nb visite de page panier : 1pt par visite
      points = lead.basket * 1
      chaleur += points
      details.basket = points
      // Visiteur a chatté : 10pts
      points = lead.hasChatted
        ? 10
        : 0
      chaleur += points
      details.hasChatted = points
      // Visiteur ciblé : 10pts
      points = lead.hasBeenTarget
        ? 10
        : 0
      chaleur += points
      details.hasBeenTarget = points
      // Duree de présence sur site : 1pt par 5 minutes
      points = _.round((lead.duration / 60) / 5)
      chaleur += points
      details.duration = points
      // Email : 10pts
      points = !_.isEmpty(lead.email)
        ? 10
        : 0
      chaleur += points
      details.email = points
      // Tel : 10pts
      points = !_.isEmpty(lead.tel) || !_.isEmpty(lead.C2C)
        ? 10
        : 0
      chaleur += points
      details.tel = points
      // Ventes passees : 10pts par vente
      points = lead.purchase * 10
      chaleur += points
      details.purchase = points
      return {
        chaleur: chaleur,
        details: details
      }
    }
  },

  watch: {
    // params (v) {
    //   this.loading = true
    //   // this.getLeadsInfos()
    //   // this.getLeads()
    //   // this.getLeads()
    //   // this.getChats()
    // },
    // leadsOfPeriod (v) {
    //   if (!v) {
    //     this.onlyCreatedLeads = false
    //   }
    // }
  },

  filters: {
    duration: function (v) {
      return moment.duration(_.toNumber(v), 'seconds').format('h [h] mm [min] ss [s] ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzEditeurLead.vue